import { InspectionStatus } from 'api';

export const formatInspectionStatus = (status: InspectionStatus | string) => {
  switch (status) {
    case 'BL':
      return 'Backlog';
    case 'PL':
      return 'Planning';
    case 'SC':
      return 'Scheduled';
    case 'CO':
      return 'Complete';
    case 'CA':
      return 'Cancelled';
    default:
      return status;
  }
};
